import api from './api';

/**
 * Service for temple-related API calls
 */

/**
 * Fetch all temples
 * @returns {Promise<Array>} Array of temple data
 */
export const fetchAllTemples = async (params = {}) => {
  try {
    const response = await api.get('/temples', { params });
    return response.data;
  } catch (error) {
    console.error('Error fetching temples:', error);
    throw error;
  }
};

/**
 * Fetch a single temple by ID
 * @param {string} templeId - The ID of the temple to fetch
 * @returns {Promise<Object>} Temple data
 */
export const fetchTempleById = async (templeId) => {
  try {
    const response = await api.get(`/temples/${templeId}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching temple ${templeId}:`, error);
    throw error;
  }
};

/**
 * Fetch a single temple by slug
 * @param {string} slug - The URL slug of the temple
 * @returns {Promise<Object>} Temple data
 */
export const fetchTempleBySlug = async (slug) => {
  const response = await api.get(`/temples/by-slug/${slug}`);
  return response.data;
};

/**
 * Fetch featured temples
 * @param {number} limit - Maximum number of temples to fetch
 * @returns {Promise<Array>} Array of featured temple data
 */
export const fetchFeaturedTemples = async (limit = 6) => {
  try {
    const response = await api.get('/temples/featured', { params: { limit } });
    return response.data;
  } catch (error) {
    console.error('Error fetching featured temples:', error);
    throw error;
  }
};
